import { useMutation } from '@tanstack/react-query';
import { PostAskRequest } from 'domain/usecases';
import { FIVE_SECONDS, showToast, TEN_SECONDS, TOAST_ERROR, TOAST_SUCCESS } from 'lib/utils';
import { makeRemotePostCreateAskRequest } from 'main/factories/usecases/ask-customer/remote-post-create-ask-request';
import { AskRequest } from '@hone-automation/common';

export const useCreateQueueRequestMutation = (setActiveTransaction: (trx: AskRequest) => void) => {
  const createAskRequets = makeRemotePostCreateAskRequest();

  return useMutation({
    mutationFn: async (data: PostAskRequest.Body) => {
      return createAskRequets.post(data);
    },
    onSuccess: data => {
      setActiveTransaction(data as AskRequest);
      showToast('Request created successfully', TOAST_SUCCESS, FIVE_SECONDS);
    },
    onError: (e: Error) => {
      showToast(e.message, TOAST_ERROR, TEN_SECONDS);
    },
  });
};
